// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toggle_toggle-container__MI5kV {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}
.Toggle_toggle-container__content__Pysxj {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 16px;
}
.Toggle_toggle-container__content__Pysxj .Toggle_input__1YYut {
  opacity: 0;
  width: 0;
  height: 0;
}
.Toggle_toggle-container__content__Pysxj .Toggle_input__1YYut:checked + .Toggle_slider__B9lFB {
  background-color: var(--m-primary);
}
.Toggle_toggle-container__content__Pysxj .Toggle_input__1YYut:checked + .Toggle_slider__B9lFB::before {
  transform: translateX(17px);
}
.Toggle_toggle-container__content__Pysxj .Toggle_slider__B9lFB {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--m-subtle-xbolder);
  transition: 0.3s;
  border-radius: 34px;
  border: 1px solid transparent;
}
.Toggle_toggle-container__content__Pysxj .Toggle_slider__B9lFB::before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 2px;
  bottom: 4px;
  top: 1.5px;
  background-color: var(--m-white);
  transition: 0.3s;
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/BaseUI/Toggle/Toggle.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AACJ;AACI;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AACR;AACQ;EACI,UAAA;EACA,QAAA;EACA,SAAA;AACZ;AACY;EACI,kCAAA;AAChB;AACgB;EACI,2BAAA;AACpB;AAIQ;EACI,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yCAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AAFZ;AAIY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;AAFhB","sourcesContent":[".toggle-container {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 14px;\n\n    &__content {\n        position: relative;\n        display: inline-block;\n        width: 34px;\n        height: 16px;\n\n        .input {\n            opacity: 0;\n            width: 0;\n            height: 0;\n\n            &:checked + .slider {\n                background-color: var(--m-primary);\n\n                &::before {\n                    transform: translateX(17px);\n                }\n            }\n        }\n\n        .slider {\n            position: absolute;\n            cursor: pointer;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background-color: var(--m-subtle-xbolder);\n            transition: .3s;\n            border-radius: 34px;\n            border: 1px solid transparent;\n\n            &::before {\n                position: absolute;\n                content: \"\";\n                height: 12px;\n                width: 12px;\n                left: 2px;\n                bottom: 4px;\n                top: 1.5px;\n                background-color: var(--m-white);\n                transition: .3s;\n                border-radius: 50%;\n            }\n        }\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggle-container": `Toggle_toggle-container__MI5kV`,
	"toggle-container__content": `Toggle_toggle-container__content__Pysxj`,
	"input": `Toggle_input__1YYut`,
	"slider": `Toggle_slider__B9lFB`
};
export default ___CSS_LOADER_EXPORT___;
